var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ce-image"},[_c('ce-header',_vm._b({},'ce-header',_vm.$props,false)),_vm._v(" "),_c('media-gallery',{attrs:{"gallery":_vm.gallery}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }